import { useState } from 'react';
import { Avatar, Grid, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import DitApprovalModal from './dit-approval-modal';

type Props = {
  id: string;
  avatarUrl?: string | null;
  name: string;
  status: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleListSave: Function;
};

const useStyles = makeStyles(() => ({
  listItem: {
    width: '95%',
    margin: 'auto',
    background: '#FFFCF0',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
    marginBottom: '20px',
    marginTop: '20px',
  },
  listTagContainer: {
    alignSelf: 'center',
  },
  listTag: {
    border: '1px solid #F76B72',
    boxSizing: 'border-box',
    borderRadius: '46px',
    width: '50px',
    textAlign: 'center',
    float: 'right',
  },
  taskTitle: { display: 'flex' },
}));

export default function ClientDitApproval({ id, avatarUrl, name, status, handleListSave }: Props) {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  return (
    <div data-testid="client-dit-approval">
      <ListItem button className={classes.listItem} onClick={handleClick}>
        <Grid container>
          <Grid item xl={11} xs={9} className={classes.taskTitle}>
            <ListItemIcon>
              <Avatar alt="Profile Photo" src={avatarUrl || '/default_avatar.svg'} />
            </ListItemIcon>
            <ListItemText primary={`${name} requires identity verification`} />
          </Grid>
          <Grid item xl={1} xs={3} className={classes.listTagContainer}>
            <div className={classes.listTag}>
              <Typography variant="caption" color="error">
                {status}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </ListItem>
      <DitApprovalModal
        showModal={showModal}
        setShowModal={setShowModal}
        onExitClick={() => setShowModal(false)}
        id={id}
        updateListState={handleListSave}
      />
    </div>
  );
}
